import { Button, Card, CardContent, Divider, FormHelperText, Grid } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import { MutableRefObject } from "react";
import { StyledTextField } from "../../../../Components/TextField/TextField";
import { BaseClient, IClinicalAnalyticsConfig } from "../../../../Types/BaseClientManagement";
import { useClinicalImportConfigState as useClinicalTrialConfigState } from "./State/ClinicalImportConfigState";
import { useClinicalTrialConfigStyles } from "./Styles/ClinicalConfigStyles";

export default function ClinicalTrialConfigCard({
  client,
  clinicalAnalyticsConfigRef,
  handleSaveClient,
}: {
  client: BaseClient;
  clinicalAnalyticsConfigRef: MutableRefObject<IClinicalAnalyticsConfig>;
  handleSaveClient: (doMigration: boolean) => void;
}) {
  const classes = useClinicalTrialConfigStyles();
  const state = useClinicalTrialConfigState(client);

  const handleSaveClinicalAnalyticsConfig = () => {
    clinicalAnalyticsConfigRef.current = {
      dialpadApiKey: state.getters.dialpadApiKey,
      facebookAdAccountId: state.getters.facebookAdAccountId,
      facebookApiKey: state.getters.facebookApiKey,
      qualtricsApiToken: state.getters.qualtricsApiToken,
      quickbaseApiToken: state.getters.quickbaseApiToken,
      quickbaseRealmHostName: state.getters.quickbaseRealmHostName,
    };
    handleSaveClient(false);
  };
  return (
    <>
      <Card className={classes.card}>
        <CardContent>
          <Grid xs={12} sm={12} item style={{ justifyContent: "flex-end" }}>
            <Grid item xs={12} sm={12}>
              <FormHelperText data-test="baseclientdetailspage-clinicaltrialconfig-title">
                Clinical Analytics Configurations
              </FormHelperText>
            </Grid>
            <Grid item xs={12} sm={12}>
              <Grid item xs={12} sm={12}>
                <FormHelperText data-test="baseclientdetailspage-dialpad-title">Dialpad</FormHelperText>
              </Grid>
              <Grid item xs={12} lg={4}>
                <StyledTextField
                  InputLabelProps={{ style: { color: "rgba(0,0,0,.6)" } }}
                  placeholder="Dialpad API Key"
                  label="Dialpad API Key"
                  variant="standard"
                  fullWidth
                  value={state.getters.dialpadApiKey}
                  onChange={(e) => state.setters.setDialpadApiKey(e.target.value)}
                  data-test="baseclientdetailspage-clinicalanalyticsconfig-dialpadapikey"
                />
              </Grid>
            </Grid>
            <Grid item xs={12} sm={12}>
              <Grid item xs={12} style={{ paddingTop: 40 }}>
                <Divider />
              </Grid>
              <Grid item xs={12} sm={12}>
                <FormHelperText data-test="baseclientdetailspage-facebookads-title">
                  Facebook Ads
                </FormHelperText>
              </Grid>
              <Grid item xs={12} lg={4}>
                <StyledTextField
                  InputLabelProps={{ style: { color: "rgba(0,0,0,.6)" } }}
                  placeholder="Facebook Ad Account Id"
                  label="Facebook Ad Account Id"
                  variant="standard"
                  fullWidth
                  value={state.getters.facebookAdAccountId}
                  onChange={(e) => state.setters.setFacebookAdAccountId(e.target.value)}
                  data-test="baseclientdetailspage-clinicalanalyticsconfig-facebookadaccountid"
                />
              </Grid>
              <Grid item xs={12} lg={4}>
                <StyledTextField
                  InputLabelProps={{ style: { color: "rgba(0,0,0,.6)" } }}
                  placeholder="Facebook API Key"
                  label="Facebook API Key"
                  variant="standard"
                  fullWidth
                  value={state.getters.facebookApiKey}
                  onChange={(e) => state.setters.setFacebookApiKey(e.target.value)}
                  data-test="baseclientdetailspage-clinicalanalyticsconfig-facebookapikey"
                />
              </Grid>
            </Grid>
            <Grid item xs={12} sm={12}>
              <Grid item xs={12} style={{ paddingTop: 40 }}>
                <Divider />
              </Grid>
              <Grid item xs={12} sm={12}>
                <FormHelperText data-test="baseclientdetailspage-googleads-title">Google Ads</FormHelperText>
              </Grid>
              <Grid item xs={12} lg={4}>
                <Alert severity="info">Google Ads is not implemented yet</Alert>
              </Grid>
            </Grid>
            <Grid item xs={12} sm={12}>
              <Grid item xs={12} style={{ paddingTop: 40 }}>
                <Divider />
              </Grid>
              <Grid item xs={12} sm={12}>
                <FormHelperText data-test="baseclientdetailspage-qualtrics-title">Qualtrics</FormHelperText>
              </Grid>
              <Grid item xs={12} lg={4}>
                <StyledTextField
                  InputLabelProps={{ style: { color: "rgba(0,0,0,.6)" } }}
                  placeholder="Qualtrics API Token"
                  label="Qualtrics API Token"
                  variant="standard"
                  fullWidth
                  value={state.getters.qualtricsApiToken}
                  onChange={(e) => state.setters.setQualtricsApiToken(e.target.value)}
                  data-test="baseclientdetailspage-clinicalanalyticsconfig-qualtricsapitoken"
                />
              </Grid>
            </Grid>
            <Grid item xs={12} sm={12}>
              <Grid item xs={12} style={{ paddingTop: 40 }}>
                <Divider />
              </Grid>
              <Grid item xs={12} sm={12}>
                <FormHelperText data-test="baseclientdetailspage-quickbase-title">Quickbase</FormHelperText>
              </Grid>
              <Grid item xs={12} lg={4}>
                <StyledTextField
                  InputLabelProps={{ style: { color: "rgba(0,0,0,.6)" } }}
                  placeholder="Quickbase API Token"
                  label="Quickbase API Token"
                  variant="standard"
                  fullWidth
                  value={state.getters.quickbaseApiToken}
                  onChange={(e) => state.setters.setQuickbaseApiToken(e.target.value)}
                  data-test="baseclientdetailspage-clinicalanalyticsconfig-quickbaseapitoken"
                />
              </Grid>
              <Grid item xs={12} lg={4}>
                <StyledTextField
                  InputLabelProps={{ style: { color: "rgba(0,0,0,.6)" } }}
                  placeholder="Quickbase Realm Hostname"
                  label="Quickbase Realm Hostname"
                  variant="standard"
                  fullWidth
                  value={state.getters.quickbaseRealmHostName}
                  onChange={(e) => state.setters.setQuickbaseRealmHostName(e.target.value)}
                  data-test="baseclientdetailspage-clinicalanalyticsconfig-quickbaserealmhostname"
                />
              </Grid>
            </Grid>
            <Grid
              xs={12}
              sm={12}
              item
              container
              style={{
                justifyContent: "flex-end",
                alignItems: "flex-end",
              }}
            >
              <Button
                disabled={false}
                onClick={() => {
                  handleSaveClinicalAnalyticsConfig();
                }}
                style={{ marginTop: "20px", marginLeft: "20px" }}
                className={classes.sensitiveButton}
                type="submit"
                variant="contained"
                color="primary"
                data-test={`baseclientdetailspage-clinicalanalyticsconfig-savebutton`}
              >
                Save Information
              </Button>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </>
  );
}
